"use client";

import { useSearchParams } from "next/navigation";

/** The read side of URLSearchParams: no append/set/delete/sort. */
export type ReadonlySearchParams = Pick<
  URLSearchParams,
  "get" | "getAll" | "has" | "toString" | "entries" | "keys" | "values" | "forEach" | "size"
> &
  Iterable<[string, string]>;

const EMPTY_SEARCH_PARAMS: ReadonlySearchParams = new URLSearchParams();

/**
 * `useSearchParams()`, never null.
 *
 * Next types `useSearchParams()` as `ReadonlyURLSearchParams | null` once the
 * app has a `src/pages` directory (Pages Router compat types; the MCP OAuth
 * mount lives in src/pages/api/oauth). In the App Router it never returns
 * null; a null (Pages Router before the router is ready) reads as "no
 * params". One shared empty instance keeps effect dependencies stable; the
 * read-only return type stops callers mutating it (copy with
 * `new URLSearchParams(params.toString())` to change params).
 */
export function useSearchParamsOrEmpty(): ReadonlySearchParams {
  return useSearchParams() ?? EMPTY_SEARCH_PARAMS;
}
